/**
 *
 * Separate file --> good for debug
 */

var radio = require('backbone.radio');
radio.DEBUG = true;


module.exports = radio;




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/radio.js
 ** module id = 72
 ** module chunks = 0
 **/